import { render, staticRenderFns } from "./serviceTypeManage.vue?vue&type=template&id=826cb9fc&scoped=true"
import script from "./serviceTypeManage.vue?vue&type=script&lang=js"
export * from "./serviceTypeManage.vue?vue&type=script&lang=js"
import style0 from "./serviceTypeManage.vue?vue&type=style&index=0&id=826cb9fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826cb9fc",
  null
  
)

export default component.exports